import { adrSearchResultListItemExtension } from '@backstage-community/plugin-adr/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';
import GavelIcon from '@material-ui/icons/Gavel';

// @backstage-community/plugin-adr's search-result-list-item extension doesn't
// set an icon (unlike techdocs/announcements/azure-devops-wiki), so ADR rows
// render without one. Override just the icon param, keeping the plugin's own
// predicate/component behavior. Must be registered under pluginId 'adr' (see
// App.tsx) so it resolves to the same extension ID and replaces the original
// rather than attaching alongside it.
export const adrSearchResultListItemIcon: ExtensionDefinition = adrSearchResultListItemExtension.override({
  params: {
    icon: <GavelIcon />,
  },
});
